import {
  BarChart3,
  Building2,
  FileCheck,
  FilePlus,
  FileText,
  HelpCircle,
  Image as ImageIcon,
  LayoutDashboard,
  MessageSquare,
  Package,
  Palette,
  RefreshCw,
  ShoppingCart,
  Sparkles,
  TestTube,
  Warehouse,
  Bookmark,
  Home,
  MoreHorizontal,
  FileSpreadsheet,
  Users,
  Filter,
} from "lucide-react";
import type { NavConfig } from "@/types/navigation";
import { TERMS } from "@/constants/terminology";

export const buyerNavConfig: NavConfig = {
  primaryCTA: {
    label: "New RFQ",
    mobileLabel: "RFQ",
    href: "/buyer/rfq/new",
    icon: FilePlus,
  },
  sections: [
    {
      id: "home",
      label: null,
      items: [
        { label: "Dashboard", href: "/buyer/dashboard", icon: LayoutDashboard },
      ],
    },
    {
      id: "discover",
      label: "DISCOVER",
      items: [
        { label: TERMS.FIND_SUPPLIERS, href: "/buyer/suppliers", icon: Building2 },
        { label: TERMS.BROWSE_PRODUCTS, href: "/buyer/products", icon: Package },
      ],
    },
    {
      id: "procurement",
      label: "PROCUREMENT",
      items: [
        {
          label: "My RFQs",
          href: "/buyer/rfqs",
          icon: FileText,
          badge: { metric: "activeRFQCount" },
        },
        {
          label: TERMS.QUOTES_NAV,
          href: "/buyer/quotes",
          icon: FileCheck,
          badge: { metric: "pendingQuoteCount" },
        },
        {
          label: TERMS.ORDERS_NAV,
          href: "/buyer/orders",
          icon: ShoppingCart,
          badge: { metric: "pendingOrderCount", variant: "warning" },
        },
      ],
    },
    {
      id: "workspace",
      label: "WORKSPACE",
      items: [
        { label: TERMS.MY_SUPPLIERS, href: "/buyer/vendors", icon: Bookmark },
        {
          label: "Reorder",
          href: "/buyer/reorder",
          icon: RefreshCw,
        },
        { label: "Inventory", href: "/buyer/inventory", icon: Warehouse },
        { label: "Samples", href: "/buyer/samples", icon: TestTube },
        { label: "Brand Assets", href: "/buyer/designs", icon: Palette },
        { label: "Art Files", href: "/buyer/art-files", icon: FileText },
      ],
    },
    {
      id: "crm",
      label: "CRM",
      items: [
        { label: "Contacts", href: "/buyer/contacts", icon: Users },
        { label: "Leads", href: "/buyer/contacts?type=prospect", icon: Users },
        { label: "CRM Integration", href: "/buyer/crm-integration", icon: FileSpreadsheet },
      ],
    },
    {
      id: "account",
      label: "ACCOUNT",
      collapsed: true,
      items: [
        { label: "Analytics", href: "/buyer/analytics", icon: BarChart3 },
        { label: "Sample Analytics", href: "/buyer/samples-analytics", icon: TestTube },
        {
          label: "Messages",
          href: "/buyer/messages",
          icon: MessageSquare,
          badge: { metric: "unreadMessageCount" },
        },
        { label: "Help Center", href: "/buyer/help", icon: HelpCircle },
      ],
    },
  ],
  mobileBottomNav: [
    { label: "Dashboard", href: "/buyer/dashboard", icon: Home },
    {
      label: "New RFQ",
      href: "/buyer/rfq/new",
      icon: FilePlus,
    },
    {
      label: "Orders",
      href: "/buyer/orders",
      icon: ShoppingCart,
      badge: { metric: "pendingOrderCount", variant: "warning" },
    },
    {
      label: "More",
      href: "#more",
      icon: MoreHorizontal,
      type: "more",
    },
  ],
};
